import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';
import constantMessages from "../messages";

export default {
    saveRestAdapter(restAdapterDto, externalSystemId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/restadapters", restAdapterDto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getAPIInfo(externalSystemId, apiId) {
        var msgType = "getSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/restadapters/api-info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "getError";
            }).finally(() => {
                if (msgType == 'getError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching api info"
                    });
                }
            });
    },
    getAdapterInfo(externalSystemId, apiId, restAdapterId) {
        var msgType = "getSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/restadapters/adapter-info/" + restAdapterId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "getError";
            }).finally(() => {
                if (msgType == 'getError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching rest adapter info"
                    });
                }
            });
    },
    deleteRestAdapter(externalSystemId, apiId, restAdapterId) {
        axios.defaults.withCredentials = true;

        return axios.delete(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/restadapters/" + restAdapterId).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    testConnection(restAdapterDto, externalSystemId, apiId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/restadapters/test-connection", restAdapterDto).then(response => {
            return response.data;

        }).catch(error => {
            let response = {};
            response.error = true;
            response.data = constantMessages.MESSAGES["adapter.test.servicerror"];
            return response;
        });
    }
}